<template>
  <div class="hg_containner">
    <img
      src="https://cdn-file.xiaojudai.cn/web/dist/haiguanCheck/hg_pic1.png"
      alt=""
      style="width: 100%"
    />
    <img
      src="https://cdn-file.xiaojudai.cn/web/dist/haiguanCheck/hg_pic2.png"
      alt=""
      style="width: 100%"
    />
  </div>
</template>

<script>
export default {
  name: "notFound",
  components: {},
  data: () => ({}),
  mounted() {},
  methods: {
    gohome() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style>
.hg_containner {
  padding-bottom: 170px;
}
</style>
